/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeletionSettings
 */
export interface DeletionSettings {
    /**
     * Whether deletion is enabled for this object
     * @type {boolean}
     * @memberof DeletionSettings
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the DeletionSettings interface.
 */
export function instanceOfDeletionSettings(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "enabled" in value;

    return isInstance;
}

export function DeletionSettingsFromJSON(json: any): DeletionSettings {
    return DeletionSettingsFromJSONTyped(json, false);
}

export function DeletionSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeletionSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
    };
}

export function DeletionSettingsToJSON(value?: DeletionSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

